import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle, X } from "lucide-react";

const Notification = ({ message, isVisible, onClose, isDarkMode }) => {
  console.log("Notification component rendered with:", { isVisible, message });
  
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // Auto-hide after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  return (
    <AnimatePresence>
  {isVisible && (
    <motion.div
      initial={{ x: 300, opacity: 0, scale: 0.9 }}
      animate={{ x: 0, opacity: 1, scale: 1 }}
      exit={{ x: 300, opacity: 0, scale: 0.9 }}
      transition={{ 
        type: "spring", 
        damping: 30, 
        stiffness: 300,
        duration: 0.4
      }}
      className="fixed bottom-6 right-6 z-[9999] max-w-xs w-full"
    >
      <div
        className={`relative overflow-hidden rounded-xl shadow-lg border backdrop-blur-sm ${
          isDarkMode
            ? "bg-gray-800/90 border-gray-700/50 text-white"
            : "bg-white/95 border-gray-200/60 text-gray-800"
        }`}
      >
        <div className="p-4">
          <div className="flex items-center space-x-3">
            {/* Subtle Icon */}
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center">
                <CheckCircle className="w-4 h-4 text-green-600" />
              </div>
            </div>
            
            {/* Content */}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium mb-0.5">
                Processing Started
              </p>
              <p className={`text-xs ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              }`}>
                {message}
              </p>
            </div>
            
            {/* Close Button */}
            <button
              onClick={onClose}
              className={`flex-shrink-0 w-6 h-6 rounded-md flex items-center justify-center transition-colors duration-200 ${
                isDarkMode
                  ? "hover:bg-gray-700/50 text-gray-500 hover:text-gray-300"
                  : "hover:bg-gray-100 text-gray-400 hover:text-gray-600"
              }`}
            >
              <X size={14} />
            </button>
          </div>
        </div>
        
        {/* Subtle Progress Bar */}
        <motion.div
          className="h-0.5 bg-green-500/60"
          initial={{ scaleX: 1 }}
          animate={{ scaleX: 0 }}
          transition={{ duration: 4, ease: "linear" }}
          style={{ transformOrigin: "left" }}
        />
      </div>
    </motion.div>
  )}
</AnimatePresence>
  );
};

export default Notification;
